import { render } from "./ArcadeRankings.vue?vue&type=template&id=0082441a&scoped=true"
import script from "./ArcadeRankings.vue?vue&type=script&lang=js"
export * from "./ArcadeRankings.vue?vue&type=script&lang=js"

import "./ArcadeRankings.vue?vue&type=style&index=0&id=0082441a&scoped=true&lang=css"

import exportComponent from "/Users/benjamin/Documents/GitHub/beatmania-app-structure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0082441a"]])

export default __exports__